/* eslint-disable class-methods-use-this */
import {
    post,
    get,
    put,
    _delete,
    apiUrl,
  } from '@/lin/plugins/axios'
  import _axios from '@/lin/plugins/axios'
  
  const _baseUri = 'plugin/project/project_winner/'
  
  class ProjectWinner {
    // constructor() {}
    async add(info) {
      const res = await post(`${_baseUri}`, info)
      return res
    }
  
    async get(id) {
      const res = await get(`${_baseUri}${id}`)
      return res
    }
  
    async edit(id, info) {
      const res = await put(`${_baseUri}${id}`, info)
      return res
    }
  
    async delete(id) {
      const res = await _delete(`${_baseUri}${id}`)
      return res
    }
  
    async gets(pageInfo) {
      const res = await get(`${_baseUri}`, pageInfo)
      return res
    }

    async getXLSX(pageInfo) {
      // const res = await get(`${_baseUri}download/xlsx`, pageInfo)
      // return res
      var url = _axios.getUri({
        url: apiUrl + _baseUri + 'download/xlsx',
        method: 'get',
        params: pageInfo,
      })

      window.open(url, '_black')
    }

    async clear(pid, type) {
      const data = {
        pid,
        type,
      }
      const res = await _delete(`${_baseUri}delete/clear`, data)
      return res
    }
  }
  
  export default new ProjectWinner()
  